// @flow

import * as React from "react";
import { useState } from "react";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";
import FormPasswordWithValidation from "../atoms/FormPasswordWithValidation";
import { strictPasswordValidator } from "@constants/Validators";

import Config from "../../constants/Config";
import ReCAPTCHA from "react-google-recaptcha";

type PropsType = {
    action: ?string,
    hiddenInputs: ?any,
};

const ResetPasswordEntryForm = (props: PropsType): React.Node => {
    const [capKey, setCapKey] = useState(null);
    return (
        <ReactForm
            pageSubmit
            method="POST"
            action={props.action || ""}
            validators={[strictPasswordValidator]}
        >
            <ReactFormField
                type="password"
                name="pass"
                required={true}
                validators={["vaxiplace-password-strict"]}
                errorMessages={{
                    required: "Please enter a password.",
                }}
                label="New password"
                placeholder=""
                fieldComponent={FormPasswordWithValidation}
            />

            <ReactFormField
                type="password"
                name="confirm-pass"
                required={true}
                match="password"
                validators={["vaxiplace-password-strict"]}
                errorMessages={{
                    required: "Please enter a confirm password.",
                    match:
                        "Password and Confirm Password fields do not match, please try again",
                }}
                label="Confirm new password"
                placeholder=""
            />

            <div className="recaptcha_validator-container">
                <ReactFormField
                    type="text"
                    name="recaptcha_validator"
                    value={capKey}
                    required={true}
                    readOnly={true}
                    errorMessage={{
                        required: "Please accept recaptcha.",
                    }}
                    label="Recaptcha"
                />
            </div>

            <ReCAPTCHA
                onChange={captchaKey => {
                    setCapKey(captchaKey);
                }}
                onExpired={() => {
                    setCapKey("");
                }}
                onErrored={() => {
                    setCapKey("");
                }}
                sitekey={Config.recaptchaSiteKey}
            />

            {capKey === "" && (
                <p className="recaptcha-error">recaptcha is needed</p>
            )}

            <button
                type="submit"
                className="button button--wide"
                onClick={() => {
                    if (capKey === null) {
                        setCapKey("");
                    }
                }}
            >
                Submit
            </button>

            {props.hiddenInputs || null}
        </ReactForm>
    );
};

export default ResetPasswordEntryForm;
